import request from '@/utils/request'

// 获取商品参数数据
export function getDataList (params) {
  return request({
    url: '/product/data/list',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/productDataManagement.js